import { useState, useCallback } from 'react';
import useHttp from '../http/useHttp';

export default function useCheckRecordTypeAssociation() {
  const { getData } = useHttp();
  const [isAssociated, setIsAssociated] = useState<boolean | null>(null);
  const [checkCount, setCheckCount] = useState<number>(0);

  const checkRecordType = useCallback(async (entityId: number, recordTypeId: number) => {
    setIsAssociated(null);
    setCheckCount((prev) => prev + 1);

    try {
      const response = await getData(
        `entityrelationship/isrecordtypeassociated?entityId=${entityId}&recordTypeId=${recordTypeId}`
      );
      setIsAssociated(response?.data ?? false);
    } catch {
      setIsAssociated(false);
    }
  }, []);

  return { checkRecordType, isAssociated, checkCount };
}